import React, { useState, useCallback, useMemo } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { QuestionCircleFilled, UserOutlined } from '@ant-design/icons';
import { Row, Col, Input, Button, Card, notification, Tooltip, Form } from 'antd';
import { LOGIN_URL } from './login-util';
import { http_request_new } from '../../http-worker/http-func';
import { withRouter } from 'react-router-dom';
import { login_props_type } from './forgot-pwd';
import { VisibleDelayed } from '../../shared-functions';
import { DrawerDelayedToShowEmail } from './shared-functions';

export const ResendEmail = withRouter(
  injectIntl((props: login_props_type) => {
    const [button_disable, set_button_disable]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false);
    const [drawer_visible, set_drawer_visible]: [1 | undefined, React.Dispatch<React.SetStateAction<1 | undefined>>] = useState<1 | undefined>();
    const { history, intl } = props;
    const sso_path = useMemo(() => props.sso_path?.replace(/^\//, '') || 'v4.0', [props.sso_path]);
    const [form] = Form.useForm();
    const { getFieldsValue } = form;
    const handleSubmit = async (): Promise<void> => {
      const { username } = getFieldsValue();
      set_button_disable(true);
      // 请求接口
      const send_res: any = await http_request_new({
        key: 'regemail',
        props,
        url: `/${sso_path}/users/${username}/regemail`,
        method: 0,
        no_refresh: 1,
        custom_warning: (response: any) => {
          const { code, message } = response;
          if (code >= 400) {
            notification.warning({
              message: intl.formatMessage({ id: 'warning' }),
              description: message
            });
          }
        }
      });
      set_button_disable(false);
      if (send_res && !send_res.code) {
        notification.success({
          message: intl.formatMessage({ id: 'success' }),
          description: intl.formatMessage({ id: 'resend_email_success' })
        });
        setTimeout(() => {
          history.push({ pathname: LOGIN_URL.signIn, state: { username: username } });
        }, 5000);
      }
    };

    const to_login = useCallback(() => {
      const redirectUri = sessionStorage.getItem('forSsoHomePath');
      if (redirectUri) {
        sessionStorage.removeItem('forSsoHomePath');
        window.location.href = redirectUri;
        return;
      }
      history.push(LOGIN_URL.signIn);
    }, [history]);

    const handle_click_info = useCallback(() => {
      set_drawer_visible(1);
    }, []);

    return (
      <Row className='retrieve-password-content' justify='center' align='middle'>
        <Card className='retrieve-password-box'>
          <Row className='box-title'>
            <FormattedMessage id='resend_email'></FormattedMessage>
          </Row>
          <Row className='box-subtitle'>
            <Col span={24}>
              <FormattedMessage id='resend_email_sub'></FormattedMessage>&nbsp;
              <Tooltip title={intl.formatMessage({ id: 'help' })}>
                <QuestionCircleFilled style={{ color: '#1890ff' }} onClick={handle_click_info} />
              </Tooltip>
            </Col>
          </Row>

          <Form className='login-form' onFinish={handleSubmit} form={form}>
            <Form.Item name='username' rules={[{ required: true, message: intl.formatMessage({ id: 'p_i_username_e' }) }]}>
              <Input
                type='email'
                prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder={intl.formatMessage({ id: 'username_email' })}
                size='large'
              />
            </Form.Item>
            <Form.Item>
              <Row className='box-button' justify='end' align='bottom'>
                <Button type='primary' size='large' htmlType='submit' className='login-form-button' disabled={button_disable}>
                  {' '}
                  <FormattedMessage id='submit'></FormattedMessage>{' '}
                </Button>
              </Row>
            </Form.Item>
          </Form>
          <Row className='box-footer' align='bottom' justify='center'>
            <span className='like-a' onClick={to_login}>
              <FormattedMessage id='r_to_login'></FormattedMessage>
            </span>
          </Row>
        </Card>
        {!!VisibleDelayed(drawer_visible) && (
          <DrawerDelayedToShowEmail {...{ intl, drawer_visible, set_drawer_visible, title: 'resend_email', height: 250, message: 'resend_email_info' }} />
        )}
      </Row>
    );
  })
);
